import { createContext, useContext, useState } from 'react';

const HatmContext = createContext();

export function HatmProvider({ children }) {
  const [state, setState] = useState({ juzs: {} });
  const [chosenJuzs, setChosenJuzs] = useState([]);
  const [alert, setAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [successAlert, setSuccessAlert] = useState(false);
  const [qrDialogOpen, setQrDialogOpen] = useState(false);
  const [shareAnchorEl, setShareAnchorEl] = useState(null);
  const [name, setName] = useState("");

  const value = {
    state,
    setState,
    chosenJuzs,
    setChosenJuzs,
    alert,
    setAlert,
    alertMessage,
    setAlertMessage,
    successAlert,
    setSuccessAlert,
    qrDialogOpen,
    setQrDialogOpen,
    shareAnchorEl,
    setShareAnchorEl,
    name,
    setName
  };

  return <HatmContext.Provider value={value}>{children}</HatmContext.Provider>;
}

export function useHatm() {
  const context = useContext(HatmContext);
  if (context === undefined) {
    throw new Error('useHatm must be used within a HatmProvider');
  }
  return context;
}
